<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
    </div>
    <div class="content-body"><section class="flexbox-container">
<div class="col-12 d-flex align-items-center justify-content-center">
    <div class="col-md-4 col-10 box-shadow-2 p-0">
        <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-header border-0">
                <div class="card-title text-center" style="font-weight: 1000;">
                  Login to Octa  <!-- <img src="assets/images/logo/logo-dark.png" alt="branding logo"> -->
                </div>
                <!-- <app-alert></app-alert> -->
                <!-- <h6 class="card-subtitle line-on-side text-muted text-center font-small-3 pt-2"><span>Easily Using</span></h6> -->
            </div>
            <div class="card-content">
                <!-- <app-social-signin></app-social-signin> -->
                <!-- <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1"><span>Login Details</span></p> -->
                <p class="card-subtitle line-on-side text-muted text-center font-large-1 mx-3 my-1"><span style="
                    font-family: ui-serif;">Octa IT Solution, LLP</span></p>
                <div class="card-body">
                    <app-custom-loader-c></app-custom-loader-c>
                            <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="tryLogin()">
                          
                        <fieldset class="form-group position-relative has-icon-left">
                            <input type="text" formControlName="UserName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.UserName.errors }"
                             id="user-name" placeholder="Username" required>
                            <div class="form-control-position">
                                <i class="feather ft-user"></i>
                            </div>
                            <div *ngIf="submitted && f.UserName.errors" class="invalid-feedback">
                                <div *ngIf="f.UserName.errors.required">Username  is required</div>
                            </div>
                        </fieldset>
                        <fieldset class="form-group position-relative has-icon-left">
                            <input type="password" placeholder="Enter Password" formControlName="Password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Password.errors }" />
                            <div class="form-control-position">
                                <i class="la la-key"></i>
                            </div>
                            <div *ngIf="submitted && f.Password.errors" class="invalid-feedback">
                                <div *ngIf="f.Password.errors.required">Password is required</div>
                            </div>

                        </fieldset>
                        <div class="form-group row">
                            <div class="col-md-6 col-12 text-center text-sm-left">
                                <div class="custom-control custom-checkbox mb-1">
                                    <a [routerLink]="['/forgot']" class="card-link">Forgot Password?</a>
                                </div>
                            </div>
                        </div>
                      
                        <button type="submit" class="btn btn-outline-info btn-block">
                          <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
                          <i class="feather ft-unlock" *ngIf="!submitted"></i> Login
                        </button>
                    </form>
                </div>
                <!-- <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1"><span>New to Modern ?</span></p>
                <div class="card-body">
                    <a [routerLink]="['/register']" class="btn btn-outline-danger btn-block"><i class="feather ft-user"></i> Register</a>
                </div> -->
            </div>
        </div>
    </div>
</div>
</section>

    </div>
  </div>
</div>
